import isFunction from 'lodash/isFunction'
import React from 'react'
import cn from 'utils/tailwind/cn'

import { hasText } from '../utils/helpers'
import Icons from './Icons'

function TableTitle({
  className,
  style,
  children,
  onClick,
  propName,
  selectedProp,
  selectedOrder,
}) {
  const hasChevron =
    hasText(propName) &&
    hasText(selectedProp) &&
    propName === selectedProp &&
    (selectedOrder === 'asc' || selectedOrder === 'desc')

    const cursorStyle = {
      'cursor-pointer': isFunction(onClick)
    }
  return (
    <th
      className={cn('p-3 text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider', cursorStyle, className)}
      {...{onClick, style}}
    >
      <div className="flex items-center space-x-2">
        <span>{children}</span>
        {hasChevron ? (
          selectedOrder === 'asc' ? (
            <Icons.ChevronDown size={3} />
          ) : (
            <Icons.ChevronUp size={3} />
          )
        ) : (
          <Icons.ChevronDown className="opacity-0" size={3} />
        )}
      </div>
    </th>
  )
}

export default TableTitle
